import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import { ToastContainer } from "react-toastify";
import {
  MdOutlineKeyboardDoubleArrowRight,
  MdOutlineKeyboardArrowRight,
  MdOutlineKeyboardDoubleArrowLeft,
  MdOutlineKeyboardArrowLeft,
} from "react-icons/md";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import Footer from "../shared/Footer";
import config from "../../config";

function NotFoundList9() {
  const navigate = useNavigate();
  const token = sessionStorage.getItem("secondaryAdminToken");

  const [loading, setLoading] = useState(false);
  const [students, setStudents] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(100);

  // Redirect if not logged in
  useEffect(() => {
    if (!token) navigate("/secondary-admin");
  }, [token, navigate]);

  useEffect(() => {
    const fetchDistricts = async () => {
      try {
        setLoading(true);
        const res = await fetch(
          `${config.API_BASE_URL}/PendingDistrictWiseDataNotFoundCount_CL9`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const data = await res.json();
        if (res.ok) setStudents(data.data?.pendingDistrict_list || []);
      } catch {
        Swal.fire("Error", "Failed to load districts", "error");
      } finally {
        setLoading(false);
      }
    };
    if (token) fetchDistricts();
  }, [token]);

  // Filter and paginate
  const filteredData = students.filter((s) => {
    const query = searchQuery.toLowerCase();
    return (
      s.totaL_DATA_NOT_FOUND?.includes(query) ||
      s.districT_NAME?.toLowerCase().includes(query)
    );
  });

  const totalPages = Math.ceil(filteredData.length / perPage);
  const indexOfLastItem = currentPage * perPage;
  const indexOfFirstItem = indexOfLastItem - perPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const handlePerPageChange = (e) => {
    setPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleViewStudents = async (districtCode) => {
    navigate("/secondary-data-not-found-class-ix", {
      state: {
        districtCode,
      },
    });
  };
  return (
    <div className="container-scroller">
      <ToastContainer position="top-right" autoClose={3000} />

      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}

      <Navbar />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-md-12 mb-3">
                <section className="content-header">
                  <h1>
                    <i className="fa fa-university" />
                    &nbsp; Data Not Found Class IX
                  </h1>
                  <ol className="breadcrumb">
                    <li>
                      <a
                        onClick={() => navigate("/secondary-admin-dashboard")}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          className="fa fa-tachometer"
                          style={{ marginRight: "5px" }}
                        ></i>{" "}
                        Home
                      </a>
                    </li>
                    <li className="active">Data Not Found Class IX</li>
                  </ol>
                </section>
              </div>
            </div>

            <div className="row">
              <div className="card">
                <div className="card-body">
                  {students.length > 0 && (
                    <div className="row">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="d-flex align-items-center">
                          <label htmlFor="rowsPerPage" className="me-2 mb-0">
                            Rows:
                          </label>
                          <div style={{ width: "250px" }}>
                            <select
                              id="rowsPerPage"
                              className="form-select form-select-sm"
                              value={perPage}
                              onChange={handlePerPageChange}
                              style={{
                                width: "80px", // or adjust as needed (80–120px)
                                paddingRight: "2rem", // ensures space for the dropdown arrow
                              }}
                            >
                              {[10, 20, 50, 100, 500].map((num) => (
                                <option key={num} value={num}>
                                  {num}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div style={{ width: "200px" }}>
                          <input
                            type="text"
                            autoComplete="new-search"
                            className="form-control form-control-sm"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="table-responsive">
                        <table className="table table-bordered table-striped">
                          <thead className="table-info">
                            <tr>
                              <th>Sl. No</th>
                              <th>District Name</th>
                              <th>Total Data Not Found Students</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentItems.length > 0 ? (
                              currentItems.map((r, i) => (
                                <tr key={i}>
                                  <td>{indexOfFirstItem + i + 1}</td>
                                  <td>{r.districT_NAME}</td>
                                  <td>{r.totaL_DATA_NOT_FOUND}</td>
                                  <td>
                                    <button
                                      className="btn btn-primary btn-sm"
                                      onClick={() =>
                                        handleViewStudents(r.districT_CODE)
                                      }
                                    >
                                      View Schools{" "}
                                      <i className="fa fa-arrow-right"></i>
                                    </button>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="4" className="text-center">
                                  No data found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      {/* Pagination */}
                      <div className="d-flex justify-content-between align-items-center mt-3">
                        <div>
                          Showing {(currentPage - 1) * perPage + 1} to{" "}
                          {Math.min(indexOfLastItem, filteredData.length)} of{" "}
                          {filteredData.length} entries
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <MdOutlineKeyboardDoubleArrowLeft
                            onClick={() => {
                              if (currentPage > 1) setCurrentPage(1);
                            }}
                            style={{
                              cursor:
                                currentPage > 1 ? "pointer" : "not-allowed",
                              opacity: currentPage > 1 ? 1 : 0.5,
                            }}
                          />

                          <MdOutlineKeyboardArrowLeft
                            onClick={() => {
                              if (currentPage > 1)
                                setCurrentPage((prev) => prev - 1);
                            }}
                            style={{
                              cursor:
                                currentPage > 1 ? "pointer" : "not-allowed",
                              opacity: currentPage > 1 ? 1 : 0.5,
                            }}
                          />

                          <span>
                            Page {currentPage} of {totalPages}
                          </span>

                          <MdOutlineKeyboardArrowRight
                            onClick={() => {
                              if (currentPage < totalPages)
                                setCurrentPage((prev) => prev + 1);
                            }}
                            style={{
                              cursor:
                                currentPage < totalPages
                                  ? "pointer"
                                  : "not-allowed",
                              opacity: currentPage < totalPages ? 1 : 0.5,
                            }}
                          />

                          <MdOutlineKeyboardDoubleArrowRight
                            onClick={() => {
                              if (currentPage < totalPages)
                                setCurrentPage(totalPages);
                            }}
                            style={{
                              cursor:
                                currentPage < totalPages
                                  ? "pointer"
                                  : "not-allowed",
                              opacity: currentPage < totalPages ? 1 : 0.5,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default NotFoundList9;
